import { SearchUsingGETQueryParams, UserDto } from 'lib_api/lib/api/gen/api';

import {
  FetchDataFunctionWithoutSort,
  TablePagination,
} from 'components/WrappedComponents/Table/types';
import { useApi } from 'hooks/ApiStoreContext';
import { backAlertMessage } from 'hooks/utils/backAlertMessage';

import { FilterDashboardComptesUtilisateurs } from '../DashboardHeader/types';

/**
 * Hook to filter search for users based on given filters.
 * It is especially used to ease the mapping between client's parameters
 * and frontend filters, by providing an intermediary Filter type.
 *
 * Return a function that can be used to fetch data for dashboards.
 */

export function useSearchUserDto(): FetchDataFunctionWithoutSort<
  UserDto,
  FilterDashboardComptesUtilisateurs
> {
  const cuController = useApi().ComptesUtilisateursControllerApi;

  return async (
    pagination: TablePagination,
    filters: Partial<FilterDashboardComptesUtilisateurs>,
  ) => {
    const queryParams: SearchUsingGETQueryParams = {
      ...filters,
      exact: false,
      page: pagination.page,
      pageSize: pagination.pageSize,
    };
    const result = await cuController
      .searchUsingGET(queryParams)
      .catch((e: Response) => {
        void backAlertMessage(e);
        throw e;
      });

    return {
      data: result.pageUsers?.elements ?? [],
      total: result.pageUsers?.totalElements ?? 0,
    };
  };
}
